import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qc flex-row" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "qc-btn flex-center",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.decrease()), ["stop"])),
      disabled: _ctx.min != null && _ctx.modelValue <= _ctx.min && _ctx.isRequired
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "sub" }, null, -1)
    ]), 8, _hoisted_2),
    _withDirectives(_createElementVNode("input", {
      type: "number",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => ($event.target.value = _ctx.modelValue))
    }, null, 544), [
      [_vModelText, _ctx.value]
    ]),
    _createElementVNode("button", {
      class: "qc-btn flex-center",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.increase()), ["stop"])),
      disabled: _ctx.max != null && _ctx.modelValue >= _ctx.max
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("div", { class: "plus" }, null, -1)
    ]), 8, _hoisted_3)
  ]))
}